import React, { useEffect, useState } from 'react';
import { getCityWeather, WeatherIcon } from '@/utils/weather';

// First meaningful city token from a destination string.
const firstCity = (dest) => {
  const tok = String(dest || '').split(/[,/&+·]|\sand\s|\sto\s/i)[0].trim();
  return tok.length >= 2 && tok.length <= 40 ? tok : '';
};

/**
 * Compact live temperature chip (keyless Open-Meteo, module-cached).
 * Renders nothing until/unless the destination's first city resolves.
 */
export const TempChip = ({ destination }) => {
  const city = firstCity(destination);
  const [wx, setWx] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!city) { setWx(null); return undefined; }
    getCityWeather(city).then((w) => { if (alive) setWx(w); }).catch(() => {});
    return () => { alive = false; };
  }, [city]);

  if (!wx?.current) return null;
  const temp = Math.round(wx.current.temperature_2m);
  return (
    <span className="inline-flex items-center gap-1 shrink-0 text-[12px] text-[#6B7280]" data-testid="m-trip-temp">
      <WeatherIcon code={wx.current.weather_code} className="h-3.5 w-3.5 text-[#0F6E56]" />
      {temp}°
    </span>
  );
};

export default TempChip;
